import React from "react";
import {Button, Col, Form, Input, List, Row} from "antd";
import CustomMap from "../Map/Map";
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import {updateContacts, updateMedia} from "../../Store/Actions/shop";
const rules = [{ required: true }];

class Contacts extends React.Component {

    state = {
        uploading: false
    };

    onContactsFinish = values => {
        const { shop } = this.props;
        this.setState({ uploading: true });
        updateContacts(shop.id, values, res => {
            this.setState({ uploading: false });
        });
    };


    onMediaFinish = values => {
        const { shop } = this.props;
        this.setState({ uploading: true });
        updateMedia(shop.id, values, res => {
            this.setState({ uploading: false });
        });
    };


    render() {
        const { shop } = this.props;
        const { uploading } = this.state;


        return (
            <div>
                <div className="uk-margin-bottom">
                    <div>
                        <h3 className="uk-h3 uk-margin-remove uk-text-bolder">
                            Contacts and social media
                        </h3>
                        <p className="uk-text-small uk-margin-remove">
                            { shop.contacts.length } contacts | { shop.social_media.length } social media
                        </p>
                    </div>
                </div>
                <Row gutter={8}>
                    <Col span={12}>
                        <div>
                            <Form initialValues={shop} onFinish={this.onContactsFinish} layout="vertical" hideRequiredMark>
                                <h3 className="uk-h4">
                                    Contacts
                                </h3>
                                <Form.List name="contacts">
                                    {(fields, { add, remove }) => {
                                        return (
                                            <div>
                                                {fields.map((field, index) => (
                                                    <Row gutter={8} key={field.key} className="uk-margin-bottom">
                                                        <Col span={6}>
                                                            <Form.Item
                                                                name={[field.name, "phone"]}
                                                                fieldKey={[field.fieldKey, "phone"]}
                                                                rules={rules}
                                                                noStyle
                                                            >
                                                                <Input size="large" placeholder="Phone number" />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={16}>
                                                            <Form.Item
                                                                name={[field.name, "details"]}
                                                                fieldKey={[field.fieldKey, "details"]}
                                                                rules={rules}
                                                                noStyle
                                                            >
                                                                <Input size="large" placeholder="Contact details" />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col flex="none">
                                                            <MinusCircleOutlined
                                                                className="dynamic-delete-button"
                                                                onClick={() => {
                                                                    remove(field.name);
                                                                }}
                                                            />
                                                        </Col>
                                                    </Row>
                                                ))}
                                                <Form.Item>
                                                    <Button
                                                        type="dashed"
                                                        onClick={() => {
                                                            add();
                                                        }}
                                                    >
                                                        <PlusOutlined /> Add field
                                                    </Button>
                                                </Form.Item>
                                            </div>
                                        );
                                    }}
                                </Form.List>
                                <Form.Item>
                                    <Button disabled={uploading} loading={uploading} type="primary" size="large" htmlType="submit">
                                        Submit changes
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div>
                            <Form initialValues={shop} onFinish={this.onMediaFinish} layout="vertical" hideRequiredMark>
                                <h3 className="uk-h4">
                                    Social media
                                </h3>
                                <Form.List name="social_media">
                                    {(fields, { add, remove }) => {
                                        return (
                                            <div>
                                                {fields.map((field, index) => (
                                                    <Row gutter={8} key={field.key} className="uk-margin-bottom">
                                                        <Col span={6}>
                                                            <Form.Item
                                                                name={[field.name, "type"]}
                                                                fieldKey={[field.fieldKey, "type"]}
                                                                rules={rules}
                                                                noStyle
                                                            >
                                                                <Input size="large" placeholder="Media type" />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={16}>
                                                            <Form.Item
                                                                name={[field.name, "data"]}
                                                                fieldKey={[field.fieldKey, "data"]}
                                                                rules={rules}
                                                                noStyle
                                                            >
                                                                <Input size="large" placeholder="Social media" />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col flex="none">
                                                            <div className="uk-text-center">
                                                                <MinusCircleOutlined
                                                                    className="dynamic-delete-button"
                                                                    onClick={() => {
                                                                        remove(field.name);
                                                                    }}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                ))}
                                                <Form.Item>
                                                    <Button
                                                        type="dashed"
                                                        onClick={() => {
                                                            add();
                                                        }}
                                                    >
                                                        <PlusOutlined /> Add field
                                                    </Button>
                                                </Form.Item>
                                            </div>
                                        );
                                    }}
                                </Form.List>
                                <Form.Item>
                                    <Button disabled={uploading} loading={uploading} type="primary" size="large" htmlType="submit">
                                        Submit changes
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                    </Col>
                </Row>

            </div>
        )
    }
}


export default Contacts



// WEBPACK FOOTER //
// ./src/Components/Shop/Contacts.js